import React from 'react';
import cx from 'classnames';
import { IconGroupItem } from '../icon-group/icon-group';
import { Container } from './styles';
export const ToolBar = (props) => {
    return (React.createElement(Container, { className: cx('toolbar', props.className), "data-role": "toolbar" },
        React.createElement("ul", { "data-role": "toolbar-icons" },
            React.createElement(IconGroupItem, null, props.leftIcon),
            React.createElement(IconGroupItem, { color: 'var(--text-color-0)' }, props.title)),
        React.createElement("div", { className: "toolbar-content", "data-role": "toolbar-content" }, props.extra)));
};
